import $ from 'jquery';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { environmentProperties } from 'app/util/environmentProperties';

const inDevelopment = process.env.NODE_ENV === 'development'; // eslint-disable-line no-process-env
const isRunningMocha =
    /HeadlessChrome/.test(window.navigator.userAgent) || document.getElementById('mocha-webpack') !== null;
const isRunningJest = process.env.JEST_WORKER_ID !== undefined; // eslint-disable-line no-process-env
const isRunningUnitTests = isRunningJest || isRunningMocha;

// don't use debug on node so test output isn't cluttered
const debug = !isRunningUnitTests && inDevelopment;

// Custom backend plugin to retrieve namespaces using dynamic imports
const backend = {
    type: 'backend',
    read: (language, namespace, callback) => {
        // The `dynamic` namespace is a special case as it's retrieved from the app server and maps to NewsdeskLocale2 values
        if (namespace === 'dynamic') {
            if (isRunningUnitTests) {
                callback(null, {});
                return;
            }

            $.ajax({
                type: 'GET',
                url: `/api/1_0/translationBundle/dynamic.cache.json?v=${window.environment.dynamicLabelsHash}`,
                contentType: 'application/json; charset=UTF-8'
            })
                .done((bundle) => callback(null, bundle))
                .catch(() => callback(null, true));

            return;
        }

        import(`app/i18n/labels/${namespace}-${language}.json`)
            .then((module) => callback(null, module.default))
            .catch(() => callback(null, true));
    }
};

i18next
    .use(backend)
    .use(initReactI18next)
    .init({
        ns: isRunningUnitTests
            ? ['analyze', 'common', 'email', 'preview', 'search', 'stats', 'dynamic']
            : ['analyze', 'common', 'email', 'search'],
        defaultNS: 'common',
        initImmediate: false,
        debug: debug,
        parseMissingKeyHandler: () => '',
        lng: environmentProperties.userLocale,
        fallbackLng: false // English fallbacks are merged as part of the webpack build process
    });

const t = i18next.t.bind(i18next);

function loadLanguageNamespace(language, namespace) {
    if (i18next.hasResourceBundle(language, namespace)) {
        return Promise.resolve();
    }

    return import(`app/i18n/labels/${namespace}-${language}.json`).then((bundle) => {
        updateLanguageNamespace(language, namespace, bundle);
        return bundle;
    });
}

function updateLanguageNamespace(language, namespace, bundle) {
    i18next.addResourceBundle(language, namespace, bundle, true, true);
}

export { i18next, loadLanguageNamespace, updateLanguageNamespace, t };
